<template>
    <v-card  style="border-radius: 1em;">
        <v-card-title>
            <h1 style="text-align: center; width: 100%">Detalhes da Proposta</h1>
        </v-card-title>
        <v-card-text class="mb-3">
            <v-layout wrap justify-space-around style="font-size: 1.1em;">
                <v-flex xs5 v-if="proposta.identificacao">
                    Número de indentificação: <b>{{proposta.identificacao}}</b>
                </v-flex>
                <v-flex xs5 v-if="proposta.modelo_faturamento">
                    Modelo: <b>{{tipos_proposta[proposta.modelo_faturamento]}}</b>
                </v-flex>
                <v-flex xs5 v-if="proposta.empresa">
                    Nome da empresa: <b>{{proposta.empresa.nome_fantasia}}</b>
                </v-flex>
                <v-flex xs5 v-if="proposta.empresa">
                    CNPJ da empresa: <b>{{proposta.empresa.cnpj}}</b>
                </v-flex>
                <v-flex xs5 v-if="proposta.data_abertura">
                    Data abertura: <b>{{proposta.data_abertura | formatDate('DD/MM/YYYY')}}</b>
                </v-flex>
                <v-flex xs5 v-if="proposta">
                    Status: <b
                        :class="proposta.status ? 'success--text' : proposta.status == null ? 'info--text' : 'error--text'">{{tipos_status[proposta.status]}}
                    </b>
                </v-flex>
                <v-flex xs5 v-if="proposta" class="mt-3">
                    <v-checkbox
                        v-model="tem_desconto"
                        color="primary"
                        class="mt-0"
                        :hide-details="tem_desconto"
                    >
                    <template slot="label">
                      <span class="body-2 grey--text">Tem desconto?</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      outline
                      v-if="tem_desconto"
                      v-model="desconto"
                      type="number"
                      class="pt-2"
                      label="Desconto"
                      suffix="%"
                      :rules="[
                        v => !!v || 'Valor Inválido',
                        v => v > 0 || 'Valor Inválido',
                        v => v < 101 || 'Valor Inválido',
                        v => verificar(v) || 'Não é permitido números reais',
                      ]"
                    >
                    </v-text-field>
                  </v-slide-x-transition>
                   <h6 v-if="!desconto_valido" class="error--text">*Desconto igual ou superior a taxa por abastecimento do posto {{posto ? posto.nome_fantasia : ''}}</h6>
                   <v-layout justify-center>
                       <v-btn small flat color="error" round v-if="!desconto_valido" @click="$router.push('/home')" style="font-size: 0.7em">Ir para tela de postos</v-btn>
                   </v-layout>
                </v-flex>
                <v-flex xs5 v-if="proposta" class="mt-3">
                    <v-checkbox
                        v-model="tem_taxa_abasteciemento"
                        color="primary"
                        class="mt-0"
                        :hide-details="tem_taxa_abasteciemento"
                    >
                    <template slot="label">
                      <span class="body-2 grey--text">Tem taxa de abastecimento?</span>
                    </template>
                  </v-checkbox>
                  <v-slide-x-transition>
                    <v-text-field
                      outline
                      v-if="tem_taxa_abasteciemento"
                      v-model="taxa_abasteciemento"
                      type="number"
                      class="pt-2"
                      label="Taxa de abastecimento"
                      suffix="%"
                      :rules="[
                        v => !!v || 'Valor Inválido',
                        v => v > -1 || 'Valor Inválido',
                        v => v < 101 || 'Valor Inválido',
                        v => verificar(v) || 'Não é permitido números reais'
                      ]"
                    ></v-text-field>
                  </v-slide-x-transition>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions class="justify-space-around" v-if="proposta && proposta.status == null">
            <v-btn color="error" class="mb-2" round @click="responderProposta(false)">
                Rejeitar
            </v-btn>
            <v-btn color="success" class="mb-2" :disabled="!desconto_valido" round @click="responderProposta(true)">
                Aceitar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        tipos_proposta: {
            credito: 'Crédito Apetrus',
            pospago: 'Pós-Pago',
            prepago: 'Pré-pago',
            presencial: 'Presencial'
        },
        tipos_status: {
            true: 'Aceita',
            false: 'Rejeitada',
            null: 'Aguardando Resposta'
        },
        arquivoAnexado: undefined,
        imagemAnexada: undefined,
        tem_taxa_abasteciemento: false,
        taxa_abasteciemento: undefined,
        tem_desconto: false,
        desconto: undefined,
        desconto_valido: true,
        posto: undefined
    }),
    props: ['proposta'],
    mounted () {
        if (this.proposta) {
            if (this.proposta.modelo_faturamente === 'credito') {
                this.taxa_abasteciemento = this.proposta.empresa.taxa_por_abastecimento != null ? this.proposta.empresa.taxa_por_abastecimento : undefined
            } else this.taxa_abasteciemento = this.proposta.empresa.taxa_por_abastecimento_carteira != null ? this.proposta.empresa.taxa_por_abastecimento_carteira : undefined
            this.tem_taxa_abasteciemento = !!this.taxa_abasteciemento
            this.desconto = this.proposta.desconto != null ? this.proposta.desconto : undefined
            this.tem_desconto = !!this.desconto
        }
    },
    watch: {
        tem_taxa_abasteciemento (val) {
            if (!val) this.taxa_abasteciemento = undefined
        },
        tem_desconto (val) {
            if (!val) {
                this.desconto = undefined
                this.desconto_valido = true
            }
        },
        desconto (val) {
            if (val) {
                this.verificarDesconto(val)
            }
        }
    },
    methods: {
        verificar (v) {
            if (!v) return false
            if (v === null) return false
            if (v.toString().search(/[.]/g) !== -1) {
                return false
            }
            return true
        },
        async verificarDesconto (desconto) {
            if (!desconto) this.desconto_valido = false
            const data = {}
            if (this.proposta.modelo_faturamento === 'credito') {
                data.taxa_recebimento_empresa__lte = desconto
            } else {
                data.taxa_proposta_apetrus__lte = desconto
            }
            const postos = await this.$store.dispatch('pegarTodosPostos', data)
            if (postos.length > 0) {
                this.posto = postos[0]
                this.desconto_valido = false
            } else {
                this.desconto_valido = true
            }
        },
        responderProposta (resposta) {
            const data = {
                resposta: resposta,
                taxa: this.taxa_abasteciemento ? this.taxa_abasteciemento : null,
                desconto: this.desconto ? this.desconto : null,
                id: this.proposta.id,
                method: 'PUT'
            }
            this.$store.dispatch('propostasApetrus', data).then(() => {
                this.$emit('carregar')
                this.$emit('success', `Proposta ${resposta ? 'aceita' : 'rejeitada'} com sucesso.`)
                this.$emit('carregar')
                this.$emit('fechar')
            }).catch(() => {
                this.$emit('error', `Não foi possível realizar operação.`)
            })
        }
    }
}
</script>
